import axios from 'axios';
import cfg_axios from '@/config/cfg_axios';

/**
 * Service for tracking website visits
 */
class VisitTracker {
  /**
   * Track a website visit
   * @param {Object} data - Additional data to send with the visit event
   * @returns {Promise} - The axios promise
   */
  static trackVisit(data = {}) {
    // Get the current page path
    const currentPath = window.location.pathname;
    const currentPage = currentPath === '/' ? 'home' : currentPath.substring(1);

    // Prepare visit data
    const visitData = new URLSearchParams();
    visitData.append('page', currentPage);
    visitData.append('referrer', document.referrer || '');
    visitData.append(
      'screen',
      JSON.stringify({
        width: window.screen.width,
        height: window.screen.height,
      })
    );
    visitData.append('language', navigator.language);

    // Add any additional data
    if (data.user) {
      visitData.append('user', data.user);
    }

    // Send the visit data to the API
    return axios
      .post(cfg_axios.base_url + '/events/visit', visitData, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .catch(error => {
        console.error('Error tracking visit:', error);
      });
  }
}

export default VisitTracker;
